const translationKeyToPaymentLogo = {
  web20_webshop_bill: '/images/svg/payment-logo-bill.svg',
  web20_webshop_mastercardcreditcard: '/images/payment-logos/cards/mastercard.svg',
  web20_webshop_visacreditcard: '/images/payment-logos/cards/visa.svg',
  web20_webshop_americanexpress: '/images/payment-logos/cards/american-express.svg',
  web20_webshop_twint: '/images/payment-logos/apm/twint.svg',
  web20_webshop_applepay: '/images/payment-logos/wallets/apple-pay.svg',
  web20_webshop_googlepay: '/images/payment-logos/wallets/google-pay.svg',
  web20_webshop_paypal: '/images/payment-logos/apm/paypal.svg',
  web20_webshop_maestrocard: '/images/payment-logos/cards/maestro.svg',
  web20_webshop_vpay: '/images/payment-logos/cards/vpay.svg',
  web20_webshop_discover: '/images/payment-logos/cards/discover.svg',
  web20_webshop_unionpay: '/images/payment-logos/cards/unionpay.svg',
  web20_webshop_alipay: '/images/payment-logos/apm/alipay.svg',
  web20_webshop_diners: '/images/payment-logos/cards/diners.svg',
  web20_webshop_dankort: '/images/payment-logos/cards/dankort.svg',
  web20_webshop_klarna: '/images/payment-logos/apm/klarna.svg',
  web20_webshop_mobilepay: '/images/payment-logos/apm/mobilepay.svg',
  web20_webshop_ideal: '/images/payment-logos/apm/ideal.svg',
  web20_webshop_vipps: '/images/payment-logos/apm/vipps.svg',
  web20_webshop_ebill: '/images/payment-logos/apm/ebill.svg',
  web20_webshop_amazonpay: '/images/payment-logos/apm/amazon-pay.svg',
  web20_webshop_cartesbancaires: '/images/payment-logos/cards/cartes-bancaires.svg',
  web20_webshop_uatp: '/images/payment-logos/cards/uatp.svg',
} as const;

export const getPaymentLogo = (translationKey: string): string | null => {
  return translationKeyToPaymentLogo[translationKey] || null;
};

export const sortPaymentMethods = (methods: string[] | null): string[] => {
  if (!methods || methods.length === 0) {
    return [];
  }
  
  const paymentOrder = Object.keys(translationKeyToPaymentLogo);
  
  const positionMap = new Map<string, number>();
  paymentOrder.forEach((method, index) => {
    positionMap.set(method, index);
  });

  // Sort the methods array based on the defined order
  return methods.sort((a, b) => {
    const positionA = positionMap.get(a) ?? Number.MAX_SAFE_INTEGER;
    const positionB = positionMap.get(b) ?? Number.MAX_SAFE_INTEGER;
    return positionA - positionB;
  });
};
